/**
 * @description 主險/附加險標識
 */
export enum ContractType {
  Main = 'M',
  Attach = 'A'
}
